<template>
  <div style="display: flex;">
    <v-dialog
      v-model="refuseDialog"
      width="600"
      persistent
    >
      <v-btn
        color="white"
        v-if="canBeReceiveFolder"
        slot="activator"
      >
        <v-icon small left>mdi-close-circle-outline</v-icon>
        Recusar
      </v-btn>

      <v-card>
        <v-toolbar color="grey lighten-3" flat>
          <v-icon class="mr-3">mdi-close-outline</v-icon>
          <span class="headline grey--text text--darken-2">Recusar Processo</span>
          <v-spacer/>
        </v-toolbar>
        <v-container grid-list-md>
          <v-card-text class="my-4 text-xs-center">
            <v-layout column align-center>
              <img class="mb-4"
                    src="/static/images/folder/grupo.svg"
                    alt="Recusar"
              />
              <span class="subheading font-weight-regular grey--text text--darken-1">Deseja recusar o recebimento deste processo?</span>
              <span class="subheading font-weight-bold">Todos os processos apensados também serão recusados.</span>
            </v-layout>

            <v-layout class="mt-3">
              <v-textarea
                label="Digite o motivo da recusa:"
                color="blue"
                v-model="refuseReason"
                box
                persistent-hint
                hint="No mínimo 20 caracteres de motivo."
              >
              </v-textarea>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn flat @click="refuseDialog = false" :disabled="refuseLoading">CANCELAR</v-btn>

              <v-dialog
                v-model="passwordConfirmation"
                width="400"
                persistent
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="black white--text"
                    @click="openPasswordConfirmation"
                    :loading="refuseLoading"
                    :disabled="refuseReason.length < 20"
                  >
                    Confirmar
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title
                    class="headline primary white--text"
                    primary-title
                  >
                    Assinar documento
                  </v-card-title>

                  <v-card-text>
                    <span>
                        Por favor, insira sua senha para confirmar a assinatura do documento
                    </span>

                    <v-text-field
                      label="Senha"
                      v-model="password"
                      type="password"
                      persistent-hint
                      hint="Sua senha de acesso"
                    />
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      @click="passwordConfirmation = false; declineFolder()"
                    >
                      Assinar
                    </v-btn>
                    <v-btn
                      color="primary"
                      flat
                      @click="passwordConfirmation = false"
                    >
                      Cancelar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="receiveDialog"
      width="600"
      persistent
    >
      <v-btn
        color="success"
        v-if="canBeReceiveFolder"
        slot="activator"
      >
        <v-icon small right>mdi-inbox-arrow-down</v-icon>
        Receber
      </v-btn>

      <v-card>
        <v-toolbar color="grey lighten-3" flat>
          <v-icon class="mr-3">mdi-inbox-arrow-down</v-icon>
          <span class="headline grey--text text--darken-2">Receber Processo</span>
          <v-spacer/>
        </v-toolbar>
        <v-container grid-list-md>
          <v-card-text class="my-4 text-xs-center">
            <v-layout column align-center>
              <img class="mb-4"
                  src="/static/images/folder/receive-folder-icon.svg"
                  alt="Receber"
              />
              <span class="subheading font-weight-bold">Todos os processos apensados também serão recebidos.</span>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn flat @click="receiveDialog = false" :disabled="receiveLoading">CANCELAR</v-btn>
              <v-btn color="black white--text" @click="receiveFolder()">Confirmar</v-btn>
            </v-layout>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import foldersService from '@/services/FoldersService';

export default {
  name: 'ReceiveOrDeclineFolder',
  props: ['canBeReceiveFolder', 'folderId'],
  data() {
    return {
      refuseDialog: false,
      receiveDialog: false,
      refuseReason: '',
      refuseLoading: false,
      receiveLoading: false,
      password: '',
      passwordConfirmation: false,
    }
  },
  methods: {
    async receiveFolder() {
      if (this.receiveLoading) return;
      try {
        this.receiveLoading = true;
        const payload = { id: this.folderId };
        this.$store.dispatch('toggleLoader', { show: true });

        await foldersService.receiveFolder(payload)
        await this.$store.dispatch('getActiveFolder', { id: this.folderId });
      } finally {
        this.$store.dispatch('toggleLoader', { show: false });
        this.receiveLoading = false;
      }
    },
    declineFolder() {
      if (this.refuseLoading) return;
      this.refuseLoading = true;

      this.$getLocation()
        .then((coordinates) => {
          foldersService.refuseFolder(this.folderId, this.refuseReason, this.password, `${coordinates.lat}, ${coordinates.lng}`)
            .then(() => {
              this.$router.push('/pastas/entrada');
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'O recebimento do processo foi recusado com sucesso.',
                messageIcon: 'mdi-check',
              });
            })
            .catch((err) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'error',
                message: err.response.data.message.toString(),
                messageIcon: 'mdi-check',
              });
            })
            .finally(() => {
              this.refuseLoading = false;
            });
        });
    },
    openPasswordConfirmation() {
      this.passwordConfirmation = true;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/ReceiveOrDeclineFolder.vue